import { useEffect, useState } from "react";

export function useMobile(){
     const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

    const updateMedia = () => {
    setIsMobile(window.innerWidth <= 600);
  };

    useEffect(() => {
        window.addEventListener("resize", updateMedia);
        return () => {
          window.removeEventListener("resize", updateMedia);
        };
      }, []);

      return isMobile;
}